import * as React from 'react';
import { useZustand } from 'use-zustand';
import { pathwayStore } from '../store';
import { Config, scrollToCurrentStep, scrollToLastStep } from '../helper';
import { Button } from './Buttons';

function LoggedIn() {
  const {
    isAllMainStepsCompleted,
  } = useZustand(pathwayStore, (state) => ({
    isAllMainStepsCompleted: state.isAllMainStepsCompleted,
  }));

  if (isAllMainStepsCompleted()) {
    return (
      <Button text={Config.I18n.Action.NextSteps} clickHandler={scrollToLastStep}/>
    );
  }

  return (
    <Button text={Config.I18n.Action.Continue} clickHandler={scrollToCurrentStep}/>
  );
}

function LoggedOut() {
  return (
    <>
      <p className='h--smallest'>
        {Config.I18n.SaveProgress}
      </p>
      <div className='btn-group'>
        <a className='nv-cta-primary nv-cta-primary--small' href={Config.Routing.login}>
          {Config.I18n.Action.SingIn}
        </a>
      </div>
    </>
  )
}

export default function UserState(props) {
  const {
    userState
  } = useZustand(pathwayStore, (state) => ({
    userState: state.userState
  }));

  if (userState === Config.UserState.unknown) {
    return null;
  }

  return (
    <div className='sidebar-block'>
      {userState === Config.UserState.loggedIn ? <LoggedIn/> : <LoggedOut/>}
    </div>
  );
}
